<script>
	import { validator } from "../validation";
	import RelativeModel from "../models/Relative";

	import Relative from "./Relative.svelte";
	import AddButton from "./buttons/AddButton.svelte";

	export let relatives = [];
	export let diagnosisType = null;
	export let disabled = null;

	const deleteRelative = (index) => {
		if (relatives.length <= 1) return;
		relatives.splice(index, 1);
		relatives = [...relatives];
	};

	const addRelative = () => {
		var errors = isValid();
		if (errors.length !== 0) {
			return;
		}

		relatives = [...relatives, new RelativeModel(diagnosisType)];
	};

	export const isValid = () => {
		return $validator.validateAll(document.querySelector("#relatives"));
	};

	if (!relatives.filter((r) => r.relativeDiagnosisType == diagnosisType).length) {
		relatives = [new RelativeModel(diagnosisType)];
	}

	console.log(relatives);
</script>

<div id="relatives">
	{#each relatives as relative, i (relative)}
		{#if relative.relativeDiagnosisType == diagnosisType}
			<div class="shadowed-box">
				<Relative
					{disabled}
					relativeIndex={i}
					bind:relative
					{diagnosisType}
					numberOfRelatives={relatives.length}
					on:delete-relative={() => deleteRelative(i)}
				/>
			</div>
		{/if}
	{/each}

	<div class="confirmation-hide">
		<AddButton on:add={addRelative}>Add Relative</AddButton>
	</div>
</div>
